import React, { Component } from "react";
import "./ResetPassword.css";
import {
  verifyForgotPassword,
  checkTokenForgotPassword,
} from "../../util/APIUtils";
import { Link, Redirect } from "react-router-dom";
import Alert from "react-s-alert";
import { CLIENT } from "../../constants";

class ResetPassword extends Component {
  constructor() {
    super();
    this.state = {
      checkSuccess: false,
    };
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("token");
    // verify(code)
    //     .then(response => {
    //         Alert.success("Congratulations, your account has been verified.");
    //         this.setState({
    //             checkSuccess: true
    //         });
    //     }).catch(error => {
    //     // this.props.history.push("/signup");
    //     // Alert.error((error && error.message) || 'Sorry, we could not verify account. It maybe already verified, or verification code is\n' +
    //     //     '                    incorrect.');
    // });

    // If the OAuth2 login encounters an error, the user is redirected to the /login page with an error.
    // Here we display the error and then remove the error query parameter from the location.
    if (this.props.location.state && this.props.location.state.error) {
      setTimeout(() => {
        Alert.error(this.props.location.state.error, {
          timeout: 5000,
        });
        this.props.history.replace({
          pathname: this.props.location.pathname,
          state: {},
        });
      }, 100);
    }
  }

  render() {
    if (this.props.authenticated) {
      return (
        <Redirect
          to={{
            pathname: "/",
            state: { from: this.props.location },
          }}
        />
      );
    }

    return (
      <div className="signup-container">
        <div className="signup-content">
          <h1 className="signup-title">Reset Password</h1>
          <ResetPasswordForm {...this.props} />
          <span className="login-link">
            Already have an account? <Link to="/login">Login!</Link>
          </span>
        </div>
      </div>
    );
  }
}

class ResetPasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: "",
      password: "",
      retype_password: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadCurrentlyClient = this.loadCurrentlyClient.bind(this);
  }

  loadCurrentlyClient() {
    var client = localStorage.getItem(CLIENT);
    if (this.props.hasOwnPropert("client")) {
      this.setState({
        clientId: this.props.client.clientId,
      });
    } else {
      this.setState({
        clientId: JSON.parse(client),
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const inputName = target.name;
    const inputValue = target.value;

    this.setState({
      [inputName]: inputValue,
    });
  }

  componentWillMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("token");
    this.setState({
      token: code,
    });
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("token");
    console.log("code: ", code);
    this.setState({
      token: code,
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    // Kiem tra token da het han hay chua
    const checkTokenRequest = Object.assign({}, { ...this.state });

    checkTokenForgotPassword(checkTokenRequest)
      .then((response) => {
        // Nếu token chua expired
        const resetPasswordRequest = Object.assign(
          {},
          {
            ...this.state,
          }
        );

        verifyForgotPassword(resetPasswordRequest)
          .then((response) => {
            Alert.success("Reset password successfully!");
            // this.props.history.push("/login");
            this.props.history.push("/login");
          })
          .catch((error) => {
            Alert.error(
              (error && error.message) ||
                "Oops! Something went wrong. Please try again!"
            );
          });
      })
      .catch((error) => {
        Alert.error(
          (error && error.message) ||
            "Oops! Something went wrong. Please try again!"
        );

        setTimeout(() => {
          this.props.history.push("/forgot-password");
        }, 1500);
      });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="form-item">
          <input
            type="password"
            name="password"
            className="form-control"
            placeholder="Password"
            value={this.state.password}
            onChange={this.handleInputChange}
            required
          />
        </div>
        <div className="form-item">
          <input
            type="password"
            name="retype_password"
            className="form-control"
            placeholder="Confirm Password"
            value={this.state.retype_password}
            onChange={this.handleInputChange}
            required
          />
        </div>
        <div className="form-item">
          <button type="submit" className="btn-8">
            <span>Reset Password</span>
          </button>
        </div>
      </form>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/user/reset_password/ResetPassword.js